<template>
    <b-button @click="$emit('input', !value)" 
        class="shadow-lg" 
        :variant="value ? 'ligh' : 'dark'"
    >
        <img src="../assets/interface/square.svg" 
            class="mx-n1" 
            :style="value ? 'height:1.5em' : 'height:1.5em;filter:invert(90%)'" 
        />
    </b-button>
</template>

<script>
export default {
    name: "UebersichtControlAreas",
    props:{
        value: Boolean
    }
}
</script>